// This is passed to classNames and as a selector for the gallery library
// to add the correct images to the reel.
export const galleryImageClassName = "_gallery_image";
